// simple state object, used in Vin65 components
// https://alligator.io/vuejs/global-event-bus/
import Vue from 'vue';
export const EventBus = new Vue();


// WEBPACK FOOTER //
// ./_js/lib/event-bus.js